import { Navbar } from "./Navbar"
import { ContactCard } from "./ContactCard"
import "./Contact.scss";
import facebookLogo from "../img_resources/facebook.png";
export function Contact() {
  const contacts = [
    { name: "Rev. Vungh En Thang", phone: "954-258-5871" },
    { name: "Sia Khup Suan Khai", phone: "409-554-5121" },
    { name: "Upa Pau Suan Lian", phone: "443-467-2983" },
    { name: "Upa NangKhawm Thang", phone: "918-812-5744" },
  ];
  const email = "ebcbowlinggreenmedia@gmail.com";
  const facebookUrl = "https://www.facebook.com/ebcbgky/";

  return (<>
    <div>
      <Navbar />
      <div className="contact">
        <h1>Have a question? Please contact one of our leaders: </h1>

        <ul className="contact-list">
          {contacts.map((c, i) => (
            <li key={i}>
              <ContactCard name={c.name} phone={c.phone}/>
            </li>
          ))}
        </ul>

        <div className="contact-links">
          <a
            className="facebook-link"
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit our Facebook page"
          >
            <img className="facebook-logo" src={facebookLogo} alt="Facebook" />
            EBC Bowling Green
          </a>
            <br/>

          <a className="email-link" href={`mailto:${email}`} aria-label="Send email">
            {email}
          </a>
        </div>
      </div>
    </div></>);
}